import { HStack, Text, Tooltip } from '@chakra-ui/react';

import { QuestionCircleFilled } from '@/client/components/icons/individual/QuestionCircleFilled';
import { useTranslation } from 'react-i18next';

interface ExpertCountLimitProps {
  /** The total number of experts used. */
  totalExperts: number;
  /** The limit of experts allowed. */
  expertsLimit: number;
  /** Whether the limit has been reached. */
  limitReached: boolean;
}

export default function ExpertCountLimit({
  totalExperts,
  expertsLimit,
  limitReached,
}: ExpertCountLimitProps) {
  const { t } = useTranslation();

  return (
    <HStack
      spacing={2}
      backgroundColor={limitReached ? 'red.50' : 'neutral.25'}
      paddingX={4}
      paddingY={3}
      borderRadius="8px"
      minWidth="fit-content"
    >
      <Text fontSize="14px" fontWeight={600} color="neutral.1200">
        {t('admin.aiAgent.limit.totalUsed', { totalExperts, expertsLimit })}
      </Text>

      <Tooltip
        hasArrow
        textAlign="center"
        label={t('admin.aiAgent.limit.tooltip', { expertsLimit })}
      >
        <QuestionCircleFilled color={limitReached ? 'red.200' : 'neutral.400'} />
      </Tooltip>
    </HStack>
  );
}
